<div class="form-group">
  @if (showLabel && question?.email_version) {
    <label [innerHtml]="question?.email_version" class="form-group__label"></label>
  }

  <ng-select
    #searchSelect
    [multiple]="false"
    [searchable]="true"
    [clearable]="true"
    [readonly]="readOnly"
    [items]="enableServerTypeahead ? (items || []) : options"
    [typeahead]="enableServerTypeahead ? typeaheadInput$ : undefined"
    [minTermLength]="enableServerTypeahead ? minSearchTermLength : 0"
    [loading]="enableServerTypeahead && loading"
    [typeToSearchText]="'Please enter ' + minSearchTermLength + ' or more characters'"
    bindLabel="answer"
    bindValue="answer"
    [placeholder]="placeHolder"
    [(ngModel)]="selectedItem"
    (change)="submit()"
    (close)="submit()">
  </ng-select>
</div>
